import { CommonImage } from '@/components/common';
import { cn } from '@/lib';
import { EventDataType } from '@/types/EventDataType.type';
import Link from 'next/link';
import React from 'react';
import { EventDescription, EventDiscount, TagsContainer } from './components';

interface EventCardProps {
  event: EventDataType;
  className?: React.ComponentProps<'div'>['className'];
}

const EventCard = ({ event, className }: EventCardProps) => {
  const isFree = event?.eventType !== 'FREE_FCFS';
  return (
    <Link
      href={`/${event.eventCode}`}
      className={cn(
        'relative top-0 flex w-full flex-col justify-between gap-1 rounded-2xl border border-gray-300 bg-white text-black transition-all ease-in',
        className,
      )}
    >
      <div>
        <CommonImage
          src={event?.poster?.[0]?.url}
          className='h-[11rem] w-full rounded-t-2xl'
          alt={event?.name}
          width={300}
          height={300}
        />
        {isFree && <EventDiscount coupons={event?.eventCoupons} />}
        <EventDescription
          {...event}
        />
      </div>
      {event?.categoryDisplay && (
        <TagsContainer category={event?.categoryDisplay || ''} />
      )}
    </Link>
  );
};

export default EventCard;
